// Allergen icon mapping for product detail view (Wyndham-style row)
export const ALLERGEN_DEFS = [
  { keys: ["gluten", "buğday", "wheat", "buğday"], icon: "fa-wheat-awn", labelTR: "Gluten", labelEN: "Gluten" },
  { keys: ["süt", "laktoz", "milk", "dairy", "süt ürünleri"], icon: "fa-bottle-droplet", labelTR: "Süt ve Süt Ürünleri", labelEN: "Milk & Dairy" },
  { keys: ["yumurta", "egg"], icon: "fa-egg", labelTR: "Yumurta", labelEN: "Egg" },
  { keys: ["soya", "soy"], icon: "fa-seedling", labelTR: "Soya", labelEN: "Soy" },
  { keys: ["hardal", "mustard"], icon: "fa-mortar-pestle", labelTR: "Hardal", labelEN: "Mustard" },
  { keys: ["fıstık", "peanut", "yer fıstığı"], icon: "fa-leaf", labelTR: "Yer Fıstığı", labelEN: "Peanut" },
  { keys: ["susam", "sesame"], icon: "fa-circle-dot", labelTR: "Susam", labelEN: "Sesame" },
  { keys: ["balık", "fish"], icon: "fa-fish", labelTR: "Balık", labelEN: "Fish" },
  { keys: ["kabuklu", "shellfish", "karides", "shrimp"], icon: "fa-shrimp", labelTR: "Kabuklu Deniz Ürünleri", labelEN: "Shellfish" },
  { keys: ["sülfit", "sulfite"], icon: "fa-flask", labelTR: "Sülfit", labelEN: "Sulfite" },
  { keys: ["kuruyemiş", "nut", "ceviz", "badem", "fındık"], icon: "fa-tree", labelTR: "Sert Kabuklu", labelEN: "Tree Nuts" },
  { keys: ["acılı", "spicy"], icon: "fa-pepper-hot", labelTR: "Acılı", labelEN: "Spicy" },
];

export function parseAllergens(text, lang) {
  if (!text) return [];
  const lower = text.toLowerCase();
  const found = [];
  const seen = new Set();
  for (const def of ALLERGEN_DEFS) {
    if (def.keys.some((k) => lower.includes(k))) {
      if (!seen.has(def.icon)) {
        seen.add(def.icon);
        found.push({ icon: def.icon, label: lang === "en" ? def.labelEN : def.labelTR });
      }
    }
  }
  return found;
}
